import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className="wb-container pt-6 pb-2 text-xs md:text-sm text-[#4A4641]"
    >
      <ol className="flex items-center flex-wrap gap-2">
        <li className="flex items-center">
          <Link to="/" className="flex items-center gap-1 hover:text-[#B94A15] font-bold" style={{ fontFamily: "'Nunito', sans-serif" }}>
            <Home className="h-3.5 w-3.5" /> Home
          </Link>
        </li>
        {items.map((it, i) => (
          <li key={i} className="flex items-center gap-2">
            <ChevronRight className="h-3.5 w-3.5 text-[#4A4641]/40" />
            {it.to && i < items.length - 1 ? (
              <Link to={it.to} className="hover:text-[#B94A15] font-bold" style={{ fontFamily: "'Nunito', sans-serif" }}>
                {it.label}
              </Link>
            ) : (
              <span className="font-bold text-[#1A1A1A]" style={{ fontFamily: "'Nunito', sans-serif" }} aria-current="page">
                {it.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
